import sha256 from 'crypto-js/sha256';
import { v4 } from 'uuid';
import { UnUploadedImage } from 'components/PhotoUpload/types';
import { Photo } from 'components/PhotoUpload/types';

export const processSignatureForUpload = async (base64: string): Promise<UnUploadedImage> => {
  const id = v4();
  const clientImageId = `signature-${id}.png`;
  const hash = sha256(base64).toString();

  return {
    id,
    type: Photo.Additional,
    base64,
    src: base64,
    alt: 'Signature',
    clientImageId,
    hash,
  };
};